const ITEMS = [
  "150,000,000 WIN Total Supply",
  "AI-Powered Trading",
  "Weekly & Monthly Payouts",
  "WIN Blockchain In Development",
  "WIN Exchange Under Development",
  "Invest Smarter. Earn Together.",
  "Built for the Future",
];

const Row = () => (
  <div className="flex shrink-0 items-center">
    {ITEMS.map((item) => (
      <div key={item} className="flex items-center">
        <span className="whitespace-nowrap px-8 font-display text-sm sm:text-base font-medium tracking-[0.14em] text-[#C9CFD9] uppercase">
          {item}
        </span>
        <span className="h-1.5 w-1.5 rotate-45 bg-[#D4AF37]/70" aria-hidden="true" />
      </div>
    ))}
  </div>
);

export default function Marquee() {
  return (
    <div
      className="relative overflow-hidden border-y border-white/[0.07] bg-[#0B0B0F]/60 py-5"
      data-testid="editorial-marquee"
      aria-hidden="true"
    >
      <div className="animate-marquee flex w-max">
        <Row />
        <Row />
      </div>
    </div>
  );
}
